import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';
import type { PaySubscriptionRequestBody, PaymentResponse } from './types';

export const paySubscriptionFn = async (body: PaySubscriptionRequestBody) => {
  const response = await httpClient.post<PaymentResponse>(
    apiRoutes.payment.subscription,
    body
  );
  return response.data;
};
